export const invitaciones2024 = [
  {
    titulo: "CAASIM-HGO-INV3-OP-01-2024",
  },
];
